module.exports = __webpack_public_path__ + "media/styles/images/svg/eraser-white-dcb4033e75ce2c66d7036c0d6078bba5.svg";